import { useEffect, useState } from 'react';
import { fetchDataByUris } from 'src/utils/api';
import { API_RESOURCES } from 'src/utils/constants';

const useDocuments = documentUris => {
  const [documentList, setDocumentList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false); // New loading state

  useEffect(() => {
    if (!documentUris?.length) return;

    const fetchDocuments = async () => {
      setLoading(true);

      try {
        const documentResults = await fetchDataByUris(API_RESOURCES.DOCUMENT, documentUris);
        const documents = Object.values(documentResults);
        setDocumentList(documents);

        const usersUris = [...new Set(documents.map(d => d.user).filter(Boolean))];
        if (!usersUris?.length) return;

        const users = await fetchDataByUris(API_RESOURCES.USERS, usersUris);
        setUserList(users);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [documentUris]);

  return { documentList, userList, loading };
};

export default useDocuments;
